import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

import backend from 'utils/backend';

const errorMessage = (error) => {
  return translate(`loomLead.LoomLeadDetail.Workflows.Complete.Errors.${error.code === 'WFL_006' ? 'WFL_006' : 'Default'}`);
};

const WorkflowCompleteDialog = (props) => {
  const {clientId, workflowId, onClose, onCompleted} = props;
  const progressWrap = props.statusProgressWrap;

  const [saving, setSaving] = React.useState(false);

  const complete = async () => {
    setSaving(true);
    await progressWrap(async () => {
      await backend.loom.loomLead.workflow.completeForClient(clientId, workflowId);
      onCompleted(workflowId);
    }, {
      onErrorMessage: errorMessage,
      debugString: 'LOOM_LEAD_COMPLETE_WORKFLOW',
    });
    setSaving(false);
  };

  return (
    <Dialog onClose={onClose}>
      <DialogTitle onClose={onClose}>
        <Translate expression='loomLead.LoomLeadDetail.Workflows.Complete.Title' />
      </DialogTitle>
      <DialogContent>
        <Typography sx={{fontSize: '14px', pt: 1}}>
          {translate('loomLead.LoomLeadDetail.Workflows.Complete.Body')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose}>
          <Translate expression='generic.Close' />
        </Button>
        <Button disabled={saving} onClick={complete}>
          <Translate expression='loomLead.LoomLeadDetail.Workflows.Complete.Confirm' />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

WorkflowCompleteDialog.propTypes = {
  clientId: PropTypes.string.isRequired,
  workflowId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompleted: PropTypes.func.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(WorkflowCompleteDialog));
